var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.busy)?_c('BlockUI',[_c('div',{staticClass:"loader"})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }